export const SIGNIN_LOADING = 'SIGNIN_LOADING';
export const SIGNIN_FAILIURE = 'SIGNIN_FAILIURE';
export const SIGNIN_SUCCESS = 'SIGNIN_SUCCESS';
export const SIGNOUT_SUCCESS = 'SIGNIN_SUCCESS';


export const GETDATA_SUCCESS = 'GETDATA_SUCCESS';
export const GETDATA_LOADING = 'GETDATA_LOADING';
export const GETDATA_FAILIURE = 'GETDATA_FAILIURE';


export const GETVIDEO_SUCCESS = 'GETVIDEO_SUCCESS';
export const GETVIDEO_LOADING = 'GETVIDEO_LOADING';
export const GETVIDEO_FAILIURE = 'GETVIDEO_FAILIURE';